
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/account/user/invoices",
      function () {
        return require("private-next-pages/[lang]/account/user/invoices.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/account/user/invoices"])
      });
    }
  